module.exports = __webpack_public_path__ + "static/Title-9d3c3785fcb93c05e2f96c8fad2f473f.woff2";